import { maskRenewalEmail, maskRenewalPhone } from './renewalFormat';

/** Canal do código de verificação. A ordem na tela segue o Figma: e-mail e depois SMS. */
export type RenewalChannel = 'email' | 'sms';

export type RenewalChannelOption = {
  channel: RenewalChannel;
  /** Contato já mascarado; vazio quando o segurado não tem esse contato. */
  contact: string;
  disabled: boolean;
};

type InsuredContacts = { email?: string | null; mobile_phone?: string | null };

const CODE_TYPE: Record<RenewalChannel, number> = { sms: 1, email: 2 };

/** `codeType` de `POST auth/send-code` e `auth/validate-code`. */
export function getRenewalCodeType(channel: RenewalChannel): number {
  return CODE_TYPE[channel];
}

export function getRenewalChannelOptions(insured: InsuredContacts): RenewalChannelOption[] {
  const email = maskRenewalEmail(insured.email);
  const phone = maskRenewalPhone(insured.mobile_phone);
  return [
    { channel: 'email', contact: email, disabled: !email },
    { channel: 'sms', contact: phone, disabled: !phone }
  ];
}

/** SMS quando há telefone (como no legado e no Figma); senão, e-mail. */
export function getDefaultRenewalChannel(insured: InsuredContacts): RenewalChannel {
  return maskRenewalPhone(insured.mobile_phone) ? 'sms' : 'email';
}
